export default __webpack_public_path__ + "media/images/home/slide_any_age_2022_lg-a6687e9751799401d719f90339f3a7b2.jpg";